module.exports = __webpack_public_path__ + "media/Selamat_Pengantin_Baru-Anita_Sarawak.79192748.mp3";